import { render, staticRenderFns } from "./PAPremium.vue?vue&type=template&id=16435e73&"
import script from "./PAPremium.vue?vue&type=script&lang=js&"
export * from "./PAPremium.vue?vue&type=script&lang=js&"
import style0 from "./PAPremium.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PAPremium.vue"
export default component.exports